import React from "react";
import ReactSelect, { components } from "react-select";
import classes from "./DropDown.module.css";
import PropTypes from "prop-types";
import Colors from "../assets/Colors";
import Fonts from "../assets/Fonts";
import { RiArrowDownSLine, RiArrowUpSLine } from "react-icons/ri";
import { ReactSVG } from "react-svg";
import { ArrowDownBlack, ArrowUpBlack } from "../../constant/imagePath";

export const DropDown = ({
  options,
  label,
  labelTwo,
  customStyle,
  disabled,
  state,
  setter,
  noBorder,
  placeholder,
  isMulti,
  style,
  Components,
  labelClassName,
  ...props
}) => {
  // console.log(options, "--------------------------");
  // alert("kp;jp");
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        {props.isFocused ? (
          <ReactSVG
            src={ArrowUpBlack}
            beforeInjection={(svg) => {
              svg.classList.add(classes.arrow);
            }}
          />
        ) : (
          <ReactSVG
            src={ArrowDownBlack}
            beforeInjection={(svg) => {
              svg.classList.add(classes.arrow);
            }}
          />
        )}
      </components.DropdownIndicator>
    );
  };

  const dropDownStyle = {
    control: (styles, { isFocused, isDisabled }) => ({
      ...styles,
      backgroundColor: isDisabled
        ? Colors.neutralShadesOfWhiteSmoke
        : Colors.white,
      padding: "0px 12px 0px 8px",
      minHeight: "48px",
      borderColor: "transparent",
      borderRadius: 10,
      border: isFocused
        ? `1px solid ${Colors.neutralShadesOfNero}`
        : `1px solid ${Colors.neutralShadesOfGainsboro}`,
      color: Colors.neutralShadesOfNero,
      boxShadow: "none",
      ...Fonts.p1,
      ":hover": {
        ...styles[":hover"],
        border: `1px solid ${Colors.neutralShadesOfNero}`,
      },
      ":placeholder": {
        color: "red",
      },

      //
    }),

    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isSelected ? Colors.mainShadeOfSolitude : Colors.white,
        color: isSelected ? Colors.mainBlue : Colors.neutralShadesOfNero,
        padding: "8px 12px",

        ":active": {
          ...styles[":active"],
          backgroundColor: Colors.mainShadeOfSolitude,
        },
        ":hover": {
          ...styles[":hover"],
          color: Colors.mainBlue,
        },
      };
    },

    multiValue: (styles, { data }) => {
      return {
        ...styles,
        backgroundColor: Colors.mainShadeOfSolitude,
        borderRadius: "8px",
        padding: "4px 8px",
        ...Fonts.p1,
      };
    },
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: Colors.neutralShadesOfNero,
      ...Fonts.p1,
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      fontSize: 12,
      color: Colors.neutralShadesOfPinkSwan,
      ...Fonts.p1,
      ":hover": {
        // backgroundColor: Colors.white,
        color: Colors.white,
      },
    }),
  };
  return (
    <div className={`${[classes.Container].join(" ")}`} style={customStyle}>
      <style jsx>{`
        .${classes.label} {
          color: ${Colors.neutralShadesOfNero};
          font-size: ${Fonts.input2.fontSize};
          line-height: 16px;
          font-family: ${Fonts.input2.fontFamily};
        }
        .${classes.disabled} {
          color: ${Colors.neutralShadesOfDimGray};
        }
      `}</style>
      {label && (
        <label
          htmlFor={`dropdown${label}`}
          className={`mb-2 ${[
            classes.label,
            labelClassName && labelClassName,
            disabled && classes.disabled,
          ].join(" ")}`}
        >
          {label}
          {labelTwo && (
            <span style={{ color: Colors.neutralShadesOfDimGray }}>
              {" " + labelTwo}
            </span>
          )}
        </label>
      )}

      <div className={`${[classes.dropdownContainer].join(" ")}`}>
        <ReactSelect
          inputId={`dropdown${label}`}
          value={state}
          onChange={(e) => {
            setter(e);
          }}
          className={`${[classes.reactSelect].join(" ")}`}
          isMulti={isMulti}
          isDisabled={disabled}
          placeholder={placeholder}
          options={options}
          styles={{ ...dropDownStyle, ...style }}
          // clearable={fals/e}
          isClearable={false}
          components={{
            IndicatorSeparator: () => null,
            DropdownIndicator: (e) => DropdownIndicator(e),
            ...Components,
          }}
          {...props}
        />
      </div>
    </div>
  );
};

DropDown.propTypes = {
  options: PropTypes.array.isRequired,
  label: PropTypes.string,
  labelTwo: PropTypes.string,
  placeholder: PropTypes.string,
  state: PropTypes.object.isRequired,
  setter: PropTypes.object,
  disabled: PropTypes.bool,
  isMulti: PropTypes.bool,
  customStyle: PropTypes.object,
  style: PropTypes.object,
  Components: PropTypes.object,
  labelClassName: PropTypes.string,
};

DropDown.defaultProps = {
  placeholder: "",
  state: null,
  disabled: false,
  isMulti: false,
  options: [],
  Components: {},
};
